/*
  ag-cart-shipping-bar.js
  Injecte une barre de progression "livraison offerte" en haut du cart drawer
  et la met a jour en live a chaque changement du panier (fetch /cart.js).
  Seuil par defaut : 6500 (en centimes) => 65,00 EUR.
*/

(() => {
  const THRESHOLD_CENTS = (window.AG_FREE_SHIPPING_THRESHOLD || 6500);
  const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const LOCALE = (document.documentElement.lang || 'fr-FR').replace('_', '-');

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: CURRENCY,
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function buildBar() {
    const bar = document.createElement('div');
    bar.className = 'ag-shipping-bar';
    bar.setAttribute('data-ag-shipping-bar', '');
    bar.innerHTML = `
      <span class="ag-shipping-bar__msg" data-msg></span>
      <div class="ag-shipping-bar__track">
        <div class="ag-shipping-bar__fill" data-fill></div>
      </div>
    `;
    return bar;
  }

  function applyState(bar, totalCents) {
    const remaining = Math.max(0, THRESHOLD_CENTS - totalCents);
    const pct = Math.min(100, Math.max(0, (totalCents / THRESHOLD_CENTS) * 100));
    const fill = bar.querySelector('[data-fill]');
    const msg = bar.querySelector('[data-msg]');
    if (fill) fill.style.width = pct + '%';

    if (remaining === 0) {
      bar.classList.add('ag-shipping-bar--reached');
      msg.innerHTML = `🎉 <strong>Livraison offerte</strong> debloquee !`;
    } else {
      bar.classList.remove('ag-shipping-bar--reached');
      msg.innerHTML = `Plus que <strong>${formatMoney(remaining)}</strong> pour la <strong>livraison offerte</strong>`;
    }
  }

  function injectInto(drawer) {
    if (!drawer) return;
    if (drawer.querySelector('[data-ag-shipping-bar]')) return;

    // On insere le shipping bar A L'INTERIEUR de .cart-drawer__items
    // (qui a son propre padding-inline natif Horizon), pour que sa boite
    // visible soit alignee a celle des cart-items__table-row.
    const items = drawer.querySelector('.cart-drawer__items, scroll-hint.cart-drawer__items');
    const header = drawer.querySelector('.cart-drawer__header');

    const bar = buildBar();
    if (items) {
      items.insertBefore(bar, items.firstChild);
    } else if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header.nextSibling);
    } else {
      return;
    }
    return bar;
  }

  function refresh() {
    const drawer = document.querySelector('.cart-drawer__dialog');
    if (!drawer) return;
    let bar = drawer.querySelector('[data-ag-shipping-bar]');
    if (!bar) {
      bar = injectInto(drawer);
      if (!bar) return;
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        // Panier vide : on masque la barre (rien a comparer)
        if (!cart || cart.item_count === 0) {
          bar.style.display = 'none';
          return;
        }
        bar.style.display = '';
        applyState(bar, cart.total_price);
      })
      .catch(() => {});
  }

  // Initial : injecter quand le DOM est pret
  function init() {
    refresh();
    // Re-render apres chaque section update Shopify (cart updates)
    document.addEventListener('cart:items-changed', refresh);
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);

    // Observer pour le drawer (au cas ou il est re-rendu)
    const mo = new MutationObserver(() => refresh());
    const root = document.body;
    mo.observe(root, { childList: true, subtree: true });

    // Quand le user ouvre le drawer (click sur le trigger), forcer un refresh
    document.addEventListener('click', e => {
      if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
        setTimeout(refresh, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
